var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gray-route-container" },
    [
      _c(
        "el-form",
        {
          staticClass: "search-form",
          attrs: { inline: true, model: _vm.queryParams, size: "small" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "城市" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "180px" },
                  attrs: { placeholder: "全部", clearable: "", filterable: "" },
                  model: {
                    value: _vm.queryParams.regionId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "regionId", $$v)
                    },
                    expression: "queryParams.regionId",
                  },
                },
                _vm._l(_vm.cityList, function (c) {
                  return _c("el-option", {
                    key: c.regionId,
                    attrs: { label: c.regionName, value: c.regionId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: { placeholder: "全部", clearable: "" },
                  model: {
                    value: _vm.queryParams.enabled,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "enabled", $$v)
                    },
                    expression: "queryParams.enabled",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "启用", value: 1 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "禁用", value: 0 } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleQuery },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", icon: "el-icon-refresh" },
                  on: { click: _vm.handleRefreshCache },
                },
                [_vm._v("刷新缓存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.list,
            border: "",
            size: "small",
            "empty-text": "暂无数据",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "70", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "城市", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getRegionName(scope.row.regionId)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "regionId",
              label: "regionId",
              width: "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.enabled === 1 ? "success" : "info",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.enabled === 1 ? "启用" : "禁用") +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: "备注",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.remark
                      ? _c("span", [_vm._v(_vm._s(scope.row.remark))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              width: "160",
              align: "center",
              formatter: _vm.formatDateTime,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "140",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#f56c6c" },
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("el-pagination", {
            staticStyle: { "margin-top": "15px", "text-align": "right" },
            attrs: {
              "current-page": _vm.queryParams.page,
              "page-size": _vm.queryParams.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [10, 20, 50, 100],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "480px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "城市", prop: "regionId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择城市",
                        filterable: "",
                        disabled: _vm.isEdit,
                      },
                      model: {
                        value: _vm.form.regionId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "regionId", $$v)
                        },
                        expression: "form.regionId",
                      },
                    },
                    _vm._l(_vm.cityList, function (c) {
                      return _c("el-option", {
                        key: c.regionId,
                        attrs: { label: c.regionName, value: c.regionId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.enabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "enabled", $$v)
                        },
                        expression: "form.enabled",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "如：8月首批灰度",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.submitLoading,
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }